import {pardakhtShakhsiService} from "@/common/api.service";

const initialStates = {
    status: 'loading',
    form_data: {
        user_name: '',
        full_name: '',
        show_phone_number: '',
        phone_number: '',
        wage_type: '',
        terminal_id: '',
        fa_gateway_name: '',
        description: '',
        user_found: '',
        profile_image: ''
    },
    direct_form_data: {
        username: '',
        payer_name: '',
        payer_email: '',
        payer_phone_number: '',
        payer_description: ''
    },
    checkout_form_data: {
        username: '',
        tracking_code: '',
        user_full_name: '',
        pay_amount: '',
        payer_wage: '',
        payer_name: '',
        payer_email: '',
        payer_phone_number: '',
        payer_description: '',
        transaction_id: '',
        payment_found: ''
    },
    receipt_form_data: {
        username: '',
        user_full_name: '',
        amount: '',
        pay_amount: '',
        payer_wage: '',
        tracking_number: '',
        bank_tracking_number: '',
        payer_phone_number: '',
        payment_status: '',
        payment_found: ''
    }
}

const mutations = {

    loading(state) {
        state.status    = 'loading'
    },
    success(state, form_data) {
        state.status    = 'success'
        state.form_data = form_data
    },
    fail(state) {
        state.status    = 'fail'
        state.form_data = []
    },
    setFormData(state, form_data) {
        state.status    = 'setFormData'
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key){
            state.form_data[key] = ''
        });
    },
    newDirect(state, direct_form_data) {
        state.status = 'newDirect'
        state.direct_form_data = direct_form_data
    },
    directCheckout(state, checkout_form_data) {
        state.status = 'directCheckout'
        state.checkout_form_data = checkout_form_data
    },
    receiptData(state, receipt_form_data) {
        state.status = 'receiptData'
        state.receipt_form_data = receipt_form_data
    }
}

const getters = {
    status: ({status}) => status,
    form_data: ({form_data}) => form_data,
    direct_form_data: ({direct_form_data}) => direct_form_data,
    checkout_form_data: ({checkout_form_data}) => checkout_form_data,
    receipt_form_data: ({receipt_form_data}) => receipt_form_data
}

const actions = {
    fetch({commit}) {
        commit('loading')
        return pardakhtShakhsiService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    find({commit}, hashid) {
        commit('loading')
        return pardakhtShakhsiService.find(hashid).then(response => {
            commit('setFormData', response.data.data)
        })
    },
    directPay({commit}, username) {
        commit('loading')
        return pardakhtShakhsiService.getDirectForm(username).then(response => {
            commit('setFormData', response.data.data)
        })
    },
    checkoutData({commit}, tracking_code) {
        commit('loading')
        return pardakhtShakhsiService.getCheckoutData(tracking_code).then(response => {
            commit('directCheckout', response.data.data)
        })
    },
    receiptData({commit}, tracking_code) {
        commit('loading')
        return pardakhtShakhsiService.getReceiptData(tracking_code).then(response => {
            commit('receiptData', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}